import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackCalendar } from '../../../../../app/models/dataPackCalendar.model';
import { CalendarService } from '../../../../../app/services/calendar.service';

/**
 * @version $Id: content.component.ts 63175 2017-09-21 02:14:43Z jonathan.c.muniz $
 */
@Component({
  selector: 'removeSpecialDay',
  templateUrl: './content.modal.template.html'
})
export class RemoveSpecialDayComponent {

  @Input() model: any;
  @Input() specialDays : any;
  private saving: boolean;

  constructor(private activeModal: NgbActiveModal, private alertService: AlertService, private calendarService: CalendarService,) {

  }

  private close() {
    this.activeModal.dismiss();
  }

  private remove() {
    let conf = { date : this.model.day,operationType : '6',description: this.model.description };
    this.calendarService.configSpecialDay(this.specialDays, conf).subscribe(
      data => {
        this.alertService.success(data['result']);
        this.activeModal.close();
      },
      err => {
        this.alertService.error(err.result, err);
        this.activeModal.dismiss();
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/removeSpecialDay/content.component.ts